import netsChatSessionKabob from './nets-chat-session-kabob';

export default angular
  .module('app.chat-session-kabob', [])
  .component('netsChatSessionKabob', netsChatSessionKabob);
